import React from 'react';
import { Segment } from 'semantic-ui-react';

import JobAssessmentsTitle from './components/JobAssessmentsTitle';
import JobAssessmentsVirtualizedTable from './components/JobAssessmentsVirtualizedTable';
import JobAssessmentViewModal from './components/JobAssessmentsViewModal';

interface Props {
    documentSetId: number;
}

export default function JobAssessments(props: Props): React.ReactElement {
    const { documentSetId } = props;

    return (
        <Segment className="job-segment">
            <JobAssessmentsTitle documentSetId={documentSetId} />
            <JobAssessmentsVirtualizedTable
                documentSetId={documentSetId}
                tableId="jobAssessments"
            />
            <JobAssessmentViewModal />
        </Segment>
    );
}
